module.exports = __webpack_public_path__ + "img/amor-face-2.66da5ecb.jpg";